import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { EstoqueService } from 'src/app/estoque/service/estoque.service';
import { Armazem } from 'src/app/interface/armazem';
import { ArmazemLookupService } from 'src/app/service/armazem-lookup-service';
import { FiltroRelatorioTransferenciasExpedicao } from '../../filter/filtro-relatorio-transferencias-expedicao';
import { Produto } from 'src/app/interface/produto';
import { ExcelService } from 'src/app/service/excel-service';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';

@Component({
  selector: 'app-relatorio-transferencias-expedicao',
  templateUrl: './relatorio-transferencias-expedicao.component.html',
  styleUrls: ['./relatorio-transferencias-expedicao.component.css']
})
export class RelatorioTransferenciasExpedicaoComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRelatorioTransferenciasExpedicao;

  advancedProdutoFilters: Array<PoDynamicFormField>;
  columnsProdutoFilters: Array<PoLookupColumn>;
  fieldFormaterProdutoFilters: ((value: Produto) => string);

  advancedArmazemFilters: Array<PoDynamicFormField>;
  columnsArmazemFilters: Array<PoLookupColumn>;
  fieldFormaterArmazemFilters: ((value: Armazem) => string);

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private poStorageService: PoStorageService,
    private router: Router,
    private estoqueService: EstoqueService,
    private excelService: ExcelService,
    public produtoLookupService: ProdutoLookupService,
    public armazemLookupService: ArmazemLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRelatorioTransferenciasExpedicao(this.poStorageService);

    this.advancedProdutoFilters = this.produtoLookupService.getAdvancedFilter();
    this.columnsProdutoFilters = this.produtoLookupService.getColumnsFilter();
    this.fieldFormaterProdutoFilters = this.produtoLookupService.getFieldFormater;

    this.advancedArmazemFilters = this.armazemLookupService.getAdvancedFilter();
    this.columnsArmazemFilters = this.armazemLookupService.getColumnsFilter();
    this.fieldFormaterArmazemFilters = this.armazemLookupService.getFieldFormater;

  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório Saldo de Armazéns' }
    ]
  };


  tabelaPrincipalLoad(): void {
    this.estoqueService.getListaRelatorioTransferenciasExpedicao(this.tabelaPrincipalFiltro.dados).subscribe((ret) => {
      this.tabelaPrincipalItens = ret.items;
    })
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'DB8DATA'    , label: 'Data'           ,width: '8%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CB8LOTECTL' , label: 'Lote'           ,width: '8%'},
    {property: 'NB8QTDORI'  , label: 'Qtd PC'         ,width: '6%', type: 'number'},
    {property: 'NB8QTDORI2' , label: 'Qtd M³'         ,width: '6%', type: 'number'},
    {property: 'NB8SALDO'   , label: 'Saldo'          ,width: '6%', type: 'number'},
    {property: 'CB8LOCAL'   , label: 'Armazém'        ,width: '6%'},
    {property: 'CZPRGENERI' , label: 'Motivo'         ,width: '60%'},
  ];

  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map( (item) => {
      return{
        'Data'  : item.DB8DATA,
        'Lote'  : item.CB8LOTECTL,
        'Qtd PC'  : item.NB8QTDORI,
        'Qtd M³'  : item.NB8QTDORI2,
        'Saldo PC'  : item.NB8SALDO,
        'Armazém' : item.CB8LOCAL,
        'Motivo' : item.CZPRGENERI,
      }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Rel Transf Exped`);
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}


